<template>
  <div id="about-contact" class="contact">
    <div class="contact-row container">
      <MyTitle>
        <template v-slot:title><b style="color: #1E55AE">联系</b>我们</template>
      </MyTitle>
      <ul>
        <li v-for="item in contactList" :key="item.id"  data-aos="fade-left" :data-aos-duration="1500">
          <div class="contact-info">
            <h1>{{ item.simpleTitle }}</h1>
            <span>————</span>
            <div>
              <p v-show="item.telephone">联系电话：{{ item.telephone }}</p>
              <p v-show="item.mobile_phone">手机号码：{{ item.mobile_phone }}</p>
              <p v-show="item.mail_num">邮 箱：{{ item.mail_num }}</p>
              <p v-show="item.qq_num">联系Q Q：{{ item.qq_num }}</p>
              <p v-show="item.address">联系地址：{{ item.address }}</p>
            </div>
          </div>
          <div class="contact-map">
            <baidu-map
                class="bm-view"
                :center="{lng: item.lng, lat: item.lat}"
                :scroll-wheel-zoom="true"
                :zoom="zoom">
              <bm-marker :position="{lng: item.lng, lat: item.lat}" :dragging="true"
                         animation="BMAP_ANIMATION_BOUNCE">
                <bm-label content="恩莱吉能源科技有限公司" :labelStyle="{color: 'red', fontSize : '15px'}"
                          :offset="{width: -80, height: 30}"/>
              </bm-marker>
              <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"/>
              <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>
              <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']"
                           anchor="BMAP_ANCHOR_TOP_LEFT"></bm-map-type>
            </baidu-map>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import BaiduMap from 'vue-baidu-map/components/map/Map'

export default {
  name: "Contact",
  components: {BaiduMap},
  data() {
    return {
      zoom: 17,
    }
  },
  computed: {
    ...mapState('about', ['contactList'])
  },
}
</script>

<style scoped lang="less">
.contact {
  .contact-row {
    margin: 80px auto;
    padding: 0 80px;
    box-sizing: border-box;

    ul {

      li {
        display: flex;
        justify-content: space-between;
        margin: 90px 0;

        .contact-info {
          width: 450px;

          h1 {
            font-size: 30px;
          }

          span {
            font-size: 24px;
            color: #1E55AE;
          }

          div {
            margin-top: 20px;
            font-size: 16px;
            line-height: 46px;
          }
        }

        .contact-map {
          width: 540px;
          height: 370px;
          background-color: #8C8C8C;

          .bm-view {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>